<template>
    <v-app>
        <Toolbar title="Device Settings"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/device/' + groupId + '/' + deviceId})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ deviceId }}</div>
                                <span class="grey--text">Group: {{ groupName }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-container grid-list-md>
                <v-layout row wrap>

                    <v-flex xs12>
                        <h3 class="headline mb-0">Device Settings</h3>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs3>
                        <v-btn color="primary" @click="fetchSettings">Revert</v-btn>
                    </v-flex>
                    <v-flex xs6>

                    </v-flex>
                    <v-flex xs3>
                        <v-btn color="error" @click="saveSettings">Save Changes</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-for="(setting, index) in settings" :key="index">

                    <v-flex xs11>
                        <v-switch v-if="typeof setting.settingValue === 'boolean'"
                                  v-model="rawSettings[setting.settingKey]"
                                  :label="setting.settingKey"
                        ></v-switch>

                        <v-text-field v-else-if="typeof setting.settingValue === 'number'"
                                      v-model="rawSettings[setting.settingKey]"
                                      :label="setting.settingKey" :value="setting.settingValue" :mask="numberMask"
                        ></v-text-field>

                        <v-text-field v-else
                                      v-model="rawSettings[setting.settingKey]"
                                      :label="setting.settingKey" :value="setting.settingValue"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs1>
                        <v-btn flat icon color="red" @click="promptDelete(setting.settingKey)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs3>
                        <v-btn color="primary" @click="fetchSettings">Revert</v-btn>
                    </v-flex>
                    <v-flex xs6>

                    </v-flex>
                    <v-flex xs3>
                        <v-btn color="error" @click="saveSettings">Save Changes</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-content>

        <v-container grid-list-md>
            <v-flex xs11 md11>
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>Add New Setting</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-card>
                    <v-card-text>
                        <v-text-field
                                label="New Setting Name" v-model="newSettingName"
                        ></v-text-field>

                        <v-select
                                v-model="newSettingType"
                                :items="items"
                                label="Setting Type"
                        ></v-select>

                        <v-switch v-if="newSettingType === 'True/False'"
                                  v-model="newSettingValue"
                                  label="New Setting Value"
                        ></v-switch>

                        <v-text-field v-else-if="newSettingType === 'Number'"
                                      label="New Setting Value" v-model="newSettingValue" :mask="numberMask"
                        ></v-text-field>

                        <v-text-field v-else
                                      label="New Setting Value" v-model="newSettingValue"
                        ></v-text-field>

                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="gray" @click="addSetting">Add</v-btn>
                    </v-card-actions>
                </v-card>

            </v-flex>
        </v-container>
        <v-dialog v-model="deleteSettingDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Delete Setting?</v-card-title>
                <v-card-text>Please confirm that you want to delete setting {{deleteKey}}.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="removeSetting(deleteKey)">Yes, delete</v-btn>
                    <v-btn color="green darken-1" flat @click.native="deleteSettingDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'

    const fb = require('../firebase')

    export default {
        name: "Settings",
        components: {Toolbar},
        data() {
            return {
                numberMask: '##########',
                settings: [],
                rawSettings: {},
                newSettingName: '',
                newSettingValue: '',
                newSettingType: 'Text',
                items: ['Text', 'Number', 'True/False'],
                deleteSettingDialog: false,
                deleteKey: ''
            }
        },
        mounted() {
            if (this.deviceId === undefined || this.deviceId === 'undefined') {
                this.$router.push({path: '/groups'})
            }
            this.fetchAll()
            this.fetchSettings()
        },
        computed: {
            groupId: function () {
                return this.$route.params['group_id']
            },
            groupName: function () {
                let group = this.$store.state.groups[this.groupId]

                if (group !== undefined) {
                    return group.name
                }
                return ''
            },
            deviceId: function () {
                return this.$route.params['device_id']
            }
        },
        methods: {
            ...mapActions(['fetchAll']),
            fetchSettings: function () {
                this.$store.commit("showProgress")
                fb.settingsCollection.doc('castles_' + this.deviceId + '@kineticsmart.com')
                    .get()
                    .then((settings) => {
                        this.$store.commit("hideProgress")
                        if (!settings.empty) {
                            this.settings = []
                            this.rawSettings = settings.data()
                            let doc = settings.data()
                            for (let key in doc) {
                                if (doc.hasOwnProperty(key)) {
                                    this.settings.push({settingKey: key, settingValue: doc[key]})
                                }
                            }

                        }
                    })
            },
            addSetting: function () {
                let outKey = this.newSettingName
                let outValue = ''

                if (this.newSettingName === '') {
                    this.$store.commit('showSnack', 'Cannot add new setting, missing setting name')
                    return
                }

                if (this.rawSettings[this.newSettingName] !== undefined) {
                    this.$store.commit('showSnack', 'Cannot add new setting, already exists')
                    return
                }

                if (this.newSettingType === 'Text') {
                    outValue = this.newSettingValue.toString()
                }
                if (this.newSettingType === 'Number') {
                    outValue = parseInt(this.newSettingValue)
                }
                if (this.newSettingType === 'True/False') {
                    outValue = !!this.newSettingValue
                }
                this.rawSettings[outKey] = outValue
                this.settings.push({
                    "settingKey": outKey,
                    "settingValue": outValue
                })
                this.newSettingName = ''
                this.newSettingValue = ''
                this.newSettingType = 'Text'

            },
            promptDelete: function (key) {
                this.deleteSettingDialog = true
                this.deleteKey = key
            },
            removeSetting: function (key) {

                let newItems = []
                this.settings.forEach(function (item) {
                    if (key !== item.settingKey) {
                        newItems.push(item)
                    }
                })
                this.settings = newItems

                delete this.rawSettings[key]

                this.deleteSettingDialog = false
                this.deleteKey = ''
            },
            saveSettings: function () {
                this.$store.commit("showProgress")
                fb.settingsCollection.doc('castles_' + this.deviceId + '@kineticsmart.com')
                    .set(this.rawSettings)
                    .then(() => {
                        this.$store.commit("hideProgress")
                        this.$store.commit('showSnack', 'Settings saved')
                    })
            }
        }
    }
</script>

<style scoped>

</style>
